import { motion } from "framer-motion";
import { ArrowRight, FileOutput } from "lucide-react";
import { useApp } from "@/context/AppProviders";

const USP = () => {
  const { t } = useApp();
  const u = t.usp;

  return (
    <section
      id="usp"
      data-testid="usp-section"
      className="py-20 sm:py-24 border-t border-border bg-card/30"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.5 }}
          className="max-w-3xl"
        >
          <p className="font-mono text-sm uppercase tracking-widest text-blue-500">
            {u.label}
          </p>
          <h2 className="font-heading mt-3 text-2xl sm:text-3xl lg:text-4xl font-semibold tracking-tight">
            {u.title}
          </h2>
          <p className="mt-4 text-base leading-relaxed text-muted-foreground">
            {u.subtitle}
          </p>
        </motion.div>

        {/* Workflow chips */}
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.5, delay: 0.1 }}
          className="mt-10 flex flex-wrap items-center gap-3"
          data-testid="usp-workflow"
        >
          {u.workflow.map((step, i) => (
            <div key={step} className="flex items-center gap-3">
              <span className="inline-flex items-center rounded-sm border border-border bg-background px-3.5 py-2 text-sm font-medium">
                <span className="mr-2 font-mono text-xs text-blue-500">
                  {String(i + 1).padStart(2, "0")}
                </span>
                {step}
              </span>
              {i < u.workflow.length - 1 && (
                <ArrowRight className="h-4 w-4 text-muted-foreground/50" />
              )}
            </div>
          ))}
        </motion.div>

        {/* Universal exports */}
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.5, delay: 0.2 }}
          className="mt-8 flex flex-wrap items-center gap-x-3 gap-y-2"
        >
          <span className="inline-flex items-center gap-2 font-mono text-xs uppercase tracking-wide text-muted-foreground">
            <FileOutput className="h-4 w-4 text-blue-500" />
            {u.exportsLabel}:
          </span>
          {u.exports.map((ex) => (
            <span
              key={ex}
              className="rounded-sm bg-secondary/60 px-2.5 py-1 font-mono text-xs text-foreground"
            >
              {ex}
            </span>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default USP;
